import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { SectionTitle } from './SectionTitle';

interface Props {
  title: string;
  actionBtn?: React.ReactNode;
  children?: React.ReactNode;
  emptyMessage?: string;
  sx?: object;
}

export const SectionCard = ({ title, actionBtn, children, emptyMessage, sx }: Props) => (
  <Paper
    elevation={1}
    sx={{
      p: 3,
      borderRadius: 2,
      border: '1px solid',
      borderColor: 'divider',
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      boxShadow: '0px 2px 12px 0px rgba(0,0,0,0.1)',
      ...sx,
    }}
  >
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <SectionTitle>{title}</SectionTitle>
      {actionBtn}
    </Box>
    {children || (
      <Typography variant="subtitle2" color="text.secondary">
        {emptyMessage}
      </Typography>
    )}
  </Paper>
);
